import axios from 'axios';
import { API_URL } from '../config/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
       // Optional: Dispatch a logout event or clear storage if needed
       // localStorage.removeItem('token');
       // window.location.href = '/login'; 
       // Keeping this minimal to avoid circular dependencies or unexpected redirects during minor glitches
    }
    return Promise.reject(error);
  }
);

export default api;
